<template>
  <vue-final-modal
    id="challenges-modal"
    class="modal"
    overlay-class="overlay"
    content-class="modal-content"
    v-bind="$attrs"
    :click-to-close="false"
    @click-outside="closeOnClickOutside"
  >
    <div :class="{wrapper: true, 'full-screen':isFullScreen, radius: !isFullScreen}">
      <icon
        class="close-modal margin-sm"
        :color="closeColor"
        icon-name="close"
        size="24px"
        @click="closeModal"
      />
      <slot name="header">
        <empty-header />
      </slot>
      <slot />
    </div>
  </vue-final-modal>
</template>

<script lang="ts" setup>
import { VueFinalModal } from 'vue-final-modal';
import Icon from '@riseupil/base-ui/src/components/Icon.vue';
import { computed } from 'vue';
import Colors from '@riseupil/base-ui/src/scss/riseup-js-colors.module.scss';
import EmptyHeader from '../EmptyHeader.vue';
import { CloseModalButtonVariants } from './modalTypes';

interface Props {
  showHeader: boolean;
  closeModal: () => void;
  closeOnOutsideClick?: boolean;
  closeIconVariant?: CloseModalButtonVariants;
  isFullScreen?: boolean;
}

const props = withDefaults(
  defineProps<Props>(),
  {
    closeIconVariant: CloseModalButtonVariants.dark,
    isFullScreen: false,
    closeOnOutsideClick: true,
  },
);

function closeOnClickOutside() {
  if (props.closeOnOutsideClick) {
    props.closeModal();
  }
}

const closeColor = computed(() =>
  (props.closeIconVariant === CloseModalButtonVariants.dark
    ? Colors.riseupBlack
    : Colors.riseupWhite));
</script>

<style lang="scss" scoped>
@import "../../scss/mixins.scss";

  .wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 85%;

    &.full-screen {
      @include responsive-page-full-width;
      @include responsive-page-full-height;
      position: absolute;
    }

    &.radius {
      border-radius: 8px;
    }

    .close-modal {
      position: absolute;
      left: 0;
      cursor: pointer;
      z-index: 1000;
    }
  }
</style>

<style lang="scss">
@import "../../scss/mixins.scss";

#challenges-modal {
  position: absolute;
  @include responsive-page-full-width;
  @include responsive-page-full-height;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
